import { IStateDispatchActions } from '../RouteInfo.context';

interface ISetRoundIdAugmentedArgs {
  roundId: string | undefined;
}

export type ISetRoundId = (args: ISetRoundIdAugmentedArgs) => any;

export const setRoundId: IStateDispatchActions<ISetRoundId> = (_, dispatch) => args => {
  const { roundId } = args;

  dispatch({ type: 'setRoundId', value: roundId });
};
